$(document).ready(function () {
  $('.collapsible-items').first().css('border-top', '1px solid rgba(58,79,65,.3)');
  $('body').on('click', '.collapsible-items .title', function () {
    const $clicked = $(this).closest('.collapsible-items');
    const isActive = $clicked.hasClass('active');
    $('.collapsible-items .text').slideUp();
    $('.collapsible-items').removeClass('active');
    if (!isActive) {
      $clicked.find('.text').slideDown();
      $clicked.addClass('active');
    }
  });
  $('.Size-guide').click(function() {
    const $popup = $('.Size-guide-inner');
      if ($popup.hasClass('active')) {
        $popup.removeClass('active');
        $('body').css('overflow', 'auto');
      } else {
        $popup.addClass('active');
        $('body').css('overflow', 'hidden');
      }
  });
  const body = document.body;
  const combinationSizeButtons = document.querySelectorAll(".combination-Size-guide");
  combinationSizeButtons.forEach(btn => {
    btn.addEventListener("click", () => {
      const index = btn.getAttribute("data-product");
      const type = btn.classList.contains("pc") ? "pc" : "mobile";
      document.querySelectorAll(".Size-guide-inner").forEach(popup => {
      popup.classList.remove("active");
      });
      const popup = document.querySelector(`.Size-guide-inner.${type}[data-product='${index}']`);
      if (popup) {
        popup.classList.add("active");
        body.style.overflow = "hidden";
      }
      const closeBtn = popup.querySelector(".Size-guide-inner-svg");
      if (closeBtn) {
        closeBtn.addEventListener("click", () => {
          popup.classList.remove("active");
          body.style.overflow = "auto";
        });
      }
    });
  });
  $('.Size-guide-inner-svg').click(function() {
    $(this).closest('.Size-guide-info').removeClass('active');
  });
  $('.Size-guide-inner-svg').click(function() {
    $('.Size-guide-inner').removeClass('active');
    $('body').css('overflow', 'auto');
  });
});


customElements.define('combination-product', class CombinationProduct extends HTMLElement {
  static price = {
    min: null,
    max: null,
    savePrice: 0
  }

  constructor() {
    super();

    this.initStatus = false;
    this.selected = false;
    this.selectedVariant = null;
  }
  
  connectedCallback() {
    if(!this.productData) return;
    
    if(CombinationProduct.price.min === null){
      CombinationProduct.price.min = this.productData.price;
    }
    if(CombinationProduct.price.max === null){
      CombinationProduct.price.max = this.productData.price;
    }
    if(this.productData.price < CombinationProduct.price.min){
      CombinationProduct.price.min = this.productData.price;
    } else if (this.productData.price > CombinationProduct.price.max) {
      CombinationProduct.price.max = this.productData.price;
    }
    if(this.productData.price < this.productData.compare_at_price){
      CombinationProduct.price.savePrice += this.productData.compare_at_price - this.productData.price;
    }
    
    this.priceContainer = document.querySelector("[data-product-price]");
    if(this.priceContainer) this.defaultPrice = this.priceContainer.innerHTML;
    this.popup = this.createPopup();
    this.addEventListener('click', (e) => {
      this.clickHandle(e);
    });
  }

  createPopup(){
    const popup = document.createElement('div');
    popup.classList.add('combination_card');
    popup.style.display = "none";
    popup.addEventListener('click', (e) => {
      if (e.target.closest('.card-variant-chose')) {
        this.closePopup();
      }
    });
    
    return popup;
  }

  showPopup(){
    document.body.classList.add("no-scroll");
    this.popup.style.display = "block";
  }

  closePopup(){
    document.body.classList.remove("no-scroll");
    this.popup.style.display = "none";
  }

  get productData(){
    return JSON.parse(this.querySelector('script[data-combination-product]').textContent || "null");
  }

  clickHandle(e){
    // 判断是否时.product-clear元素点击事件
    if(e.target.classList.contains('product-clear')){
      this.clearVariant();
      return;
    }
    if(this.initStatus){
      this.showPopup();
      return;
    }
    this.productElement = this.querySelector('template[combination-item-chose]').content.firstElementChild.cloneNode(true);
    if(!this.productElement) return;
    this.popup.appendChild(this.productElement);

    document.querySelectorAll('.combination-Size-guide').forEach(btn => {
      btn.setAttribute('data-product', this.dataset.index);
    });

    document.body.appendChild(this.popup);
    this.showPopup();
    this.initStatus = true;
  }

  chooseOption(variant, options){
    if(!variant) return;
    this.renderVariant(variant, options);
    this.selected = true;
    this.checkAnyCombinationSelected();
    this.closePopup();
    document.dispatchEvent(new CustomEvent('combination:change'));
  }

  clearVariant(){
    this.selected = false;
    this.selectedVariant = null;
    let html = `
      <div class="product-variant-info">
        <div class="">Please Select Dog Jacket</div>
      </div>
      <div class="product-control">
        <div class="product-select">select</div>
      </div>
    `;
    this.querySelector(".kit-select").innerHTML = html;
    this.querySelectorAll(".variant-image").forEach(img => {
      img.src = this.productData.featured_image + "&width=200";
    });
    this.checkAnyCombinationSelected();
    document.dispatchEvent(new CustomEvent('combination:change'));
  }

  renderVariant(variant, options){
    this.selectedVariant = variant;
    let html = `
      <div class="product-variant-info">
        <input data-variant-input type="hidden" value="${variant.id}">
        ${ Object.keys(options).map(key => `<div class="variant-${key.toLowerCase()}">${key}: <span>${options[key]}</span></div>`).join('')}
      </div>
      <div class="product-control">
        <div class="product-select">edit</div>
        <div style="text-align: center;" class="product-clear">clear</div>
      </div>
    `;
    this.querySelector(".kit-select").innerHTML = html;
    this.querySelectorAll(".variant-image").forEach(img => {
      img.src = variant.featured_image.src + "&width=200";
    });
  }

  checkAnyCombinationSelected() {
    const combination_products = document.querySelectorAll("combination-product");
    const anySelected = Array.from(combination_products).some(product => product.selected);
    
    if (anySelected) {
      $('.quantity_selector-buy_buttons-box .buy-buttons-inner').css({
        'cursor': 'pointer',
        'opacity': '1',
        'pointer-events': 'auto'
      });
    } else {
      $('.quantity_selector-buy_buttons-box .buy-buttons-inner').css({
        'cursor': 'not-allowed',
        'opacity': '0.5',
        'pointer-events': 'none'
      });
    }
    if(this.priceContainer){
      let compare_at_price = 0, totalPrice = 0, allChoose = true, allUnchoose = true;
      combination_products.forEach(product => {
        if(product.selected && product.selectedVariant){
          compare_at_price += product.selectedVariant.price;
        }
        if(product.selected){
          allUnchoose = false;
        }else{
          allChoose = false;
        }
      });
      totalPrice = compare_at_price;
      if(allUnchoose){
        this.priceContainer.innerHTML = this.defaultPrice;
        return;
      }
      if(allChoose && this.priceContainer){
        let savingPrice = this.priceContainer.dataset.savingPrice;
        if(savingPrice){
          totalPrice -= Number(savingPrice);
        }
      }
      if(totalPrice < compare_at_price){
        this.priceContainer.innerHTML = `
          <span class="price-wrapper-product-price">
            <span class="notranslate ht-money">${ window.theme.Currency.formatMoney(totalPrice) }</span>
          </span>
          <span class="product-compare-at-price">
            <span class="notranslate ht-money">${ window.theme.Currency.formatMoney(compare_at_price) }</span>
          </span>
          <span class="product-discount-amount">
            Save <span class="notranslate ht-money">${ window.theme.Currency.formatMoney(compare_at_price - totalPrice) }</span>
          </span>`;
      } else {
        this.priceContainer.innerHTML = `<span class="price-wrapper-product-price">${ window.theme.Currency.formatMoney(totalPrice) }</span>`;
      }
        
    }
    
    return anySelected;
  }
});

function checkAllKitsSelected() {
  const combination_products = document.querySelectorAll("combination-product");
  if (combination_products.length > 0) {
    const anySelected = Array.from(combination_products).some(product => product.selected);
    if (anySelected) {
      $('.quantity_selector-buy_buttons-box .buy-buttons-inner').css({
        'cursor': 'pointer',
        'opacity': '1',
        'pointer-events': 'auto'
      });
    } else {
      $('.quantity_selector-buy_buttons-box .buy-buttons-inner').css({
        'cursor': 'not-allowed',
        'opacity': '0.5',
        'pointer-events': 'none'
      });
    }
    return anySelected;
  }
  
  const kitSelects = document.querySelectorAll('.kit-select');
  if (kitSelects.length > 0) {
    const anySelected = Array.from(kitSelects).some(kit => {
      const variantInput = kit.querySelector('[data-variant-input]');
      return variantInput && variantInput.value;
    });
    if (anySelected) {
      $('.quantity_selector-buy_buttons-box .buy-buttons-inner').css({
        'cursor': 'pointer',
        'opacity': '1',
        'pointer-events': 'auto'
      });
    } else {
      $('.quantity_selector-buy_buttons-box .buy-buttons-inner').css({
        'cursor': 'not-allowed',
        'opacity': '0.5',
        'pointer-events': 'none'
      });
    }
    return anySelected;
  }
  
  return false;
}

$(document).ready(function() {
  $(document).on('change', '.combination_info input[name*="[Color]"], .combination_info input[name*="[Size]"], .combination_info input[name*="[Length]"]', function() {
    let $combo = $(this).closest('.combination_info');
    let $btn = $combo.find('.card-variant');

    let colorVal = $combo.find('input[name*="[Color]"]').length ? $combo.find('input[name*="[Color]"]:checked').val() : true;
    let sizeVal = $combo.find('input[name*="[Size]"]').length ? $combo.find('input[name*="[Size]"]:checked').val() : true;
    let lengthVal = $combo.find('input[name*="[Length]"]').length ? $combo.find('input[name*="[Length]"]:checked').val() : true;

    if (!colorVal || !sizeVal || !lengthVal) {
      $btn.addClass('disabled');
    } else {
      $btn.removeClass('disabled');
    }

    let $wrapper = $combo.closest('.combination_item-chose');
    let comboId = $wrapper.attr('data-combination-id');
    if (comboId) {
      let $originalProduct = $('combination-product[combination-id="' + comboId + '"]');
      if ($originalProduct.length) {
        let productJsonScript = $originalProduct.find('script[data-combination-product]');
        if (productJsonScript.length) {
          let productData = JSON.parse(productJsonScript.html());
          
          let currentOptions = [];
          let optionsComplete = true;
          
          productData.options.forEach(optName => {
             let $input = $combo.find(`input[name*="[${optName}]"]:checked`);
             if ($input.length) {
                 currentOptions.push($input.val());
             } else {
                 let $select = $combo.find(`select[name*="[${optName}]"]`);
                 if ($select.length) {
                     currentOptions.push($select.val());
                 } else {
                     optionsComplete = false;
                 }
             }
          });

          if (optionsComplete) {
             let matchedVariant = productData.variants.find(v => {
                 return v.options.length === currentOptions.length && 
                        v.options.every((val, i) => val === currentOptions[i]);
             });

             if (matchedVariant) {
                let price = matchedVariant.price;
                let comparePrice = matchedVariant.compare_at_price;
                let moneyFormat = window.money_format || "${{amount}}";
                
                if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
                    $combo.find('.inner-product-price').html(Shopify.formatMoney(price, moneyFormat));
                    if (comparePrice > price) {
                        $combo.find('.product-compare-at-price').html(Shopify.formatMoney(comparePrice, moneyFormat)).show();
                    } else {
                        $combo.find('.product-compare-at-price').hide();
                    }
                } else {
                    let symbol = "$"; 
                    let currentText = $combo.find('.inner-product-price').text().trim();
                    if(currentText) symbol = currentText.replace(/[0-9.,\s]/g, '').substring(0,1) || "$";
                    
                    $combo.find('.inner-product-price').text(symbol + (price / 100).toFixed(2));
                    if (comparePrice > price) {
                        $combo.find('.product-compare-at-price').text(symbol + (comparePrice / 100).toFixed(2)).show();
                    } else {
                        $combo.find('.product-compare-at-price').hide();
                    }
                }
                
                if (comparePrice > price) {
                    let discount = comparePrice - price;
                    let percent = Math.round((discount * 100) / comparePrice);
                    let $discountBadge = $combo.find('.product-discount');
                    if($discountBadge.length) {
                        let text = $discountBadge.text();
                        $discountBadge.text(text.replace(/\d+%/, percent + '%')).show();
                    }
                    let $saveAmount = $combo.find('.product-discount-amount');
                    if ($saveAmount.length) {
                        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
                            $saveAmount.text('Save ' + Shopify.formatMoney(discount, moneyFormat)).show();
                        } else {
                            let symbol = "$";
                            let currentText = $combo.find('.inner-product-price').text().trim();
                            if(currentText) symbol = currentText.replace(/[0-9.,\s]/g, '').substring(0,1) || "$";
                            $saveAmount.text('Save ' + symbol + (discount / 100).toFixed(2)).show();
                        }
                    }
                } else {
                    $combo.find('.product-discount-amount').hide();
                    let $discountBadge = $combo.find('.product-discount');
                    if($discountBadge.length) {
                        $discountBadge.hide();
                    }
                }
             }
          }
        }
      }
    }
  });

});